import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'normalize.css'
import '@/assets/css/base.scss'
import Icon from '@/components/icon/icon'

// import api from '@/apis'
import config from './config/app.js'
import { http } from '@/utils/http.js'

import * as filters from '@/filter/filters'


Vue.component('icon', Icon)
Vue.config.productionTip = false
Vue.prototype.$appConf = config
// Vue.prototype.$api = api
Vue.prototype.$http = http

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')